window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.ImageEdit = window.NPS.Views.ImageEdit || {};

window.NPS.Views.ImageEdit.create = (function($, _) {
	var _super = NPS.Views.Editor;

    function editor(el, opts) {
        opts.path = opts.root + '/edition/editors/images/';
        _super.call(this, el, opts);
    }
    editor.prototype = Object.create(_super.prototype);
    editor.prototype.constructor = editor;


    editor.prototype.load = function (page, data, done) {
    	var self = this;
        return _super.prototype.load.call(this, page, data, done).then(function(r) {
        	var $view = self.$el.find('[data-view]');
        	var creator = window.NPS.Views.ImageEdit.Views[$view.data('view')];

            opts = _.extend({}, self.opts, {container: self, loader: r.loader});
        	self.view = new creator($view, opts);
			self.view.stage(data);

        	return r;
        });
    };

    return function(el, opts) {
        return new editor(el, opts);
    };

})(window.jQuery, window._);